<template>
  <div class="row" align="center" id="seccion_botones">
    <div class="col container botButtons" align="center">
      <div class="row">
        <div class="col-auto">
          <button
            :disabled="
              !(
                requerimiento.link.includes('scorm') &&
                permitirMaterial &&
                requerimiento.prerrequisito == 0
              )
            "
            type="button"
            class="btn waves-effect waves-light btn-info"
            :id="'estudiarScorm' + requerimiento.cve_tema"
            href=""
            @click="
              () => {
                desactivarPopovers();
                $emit('EstudiarScorm');
              }
            "
          >
            <i class="fas fa-laptop"></i>
          </button>

          <b-popover :target="'estudiarScorm' + requerimiento.cve_tema" triggers="hover focus">
            <template #title>{{$t('popovers.iniciar_curso.title')}}</template>
          </b-popover>
        </div>
      </div>
      <div
        style="text-transform: uppercase;"
        :class="
          'row textUnder ' +
            !(
              requerimiento.link.includes('scorm') &&
              permitirMaterial &&
              requerimiento.prerrequisito == 0
            )
        "
      >
        {{ $t("page.general.curso") }}
      </div>
    </div>
    <div class="col container botButtons" align="center">
      <div class="row">
        <div class="col-auto">
          <button
            :disabled="
              !(
                (requerimiento.material || requerimiento.meeting) &&
                permitirMaterial &&
                requerimiento.prerrequisito == 0
              )
            "
            type="button"
            class="btn waves-effect waves-light btn-info"
            :id="'verMaterial' + requerimiento.cve_tema"
            href=""
            @click="
              () => {
                desactivarPopovers();
                $emit('VerMaterial');
              }
            "
          >
            <i class="fas fa-file-alt"></i>
          </button>

          <b-popover :target="'verMaterial' + requerimiento.cve_tema" triggers="hover focus">
            <template #title>{{$t('popovers.ver_material.title')}}</template>
          </b-popover>
        </div>
      </div>
      <div
        :class="
          'row textUnder ' +
            !(
              (requerimiento.material || requerimiento.meeting) &&
              permitirMaterial &&
              requerimiento.prerrequisito == 0
            )
        "
      >
        MATERIAL
      </div>
    </div>
    <div class="col container botButtons" align="center">
      <div class="row">
        <div class="col-auto">
          <span
            :id="'confirmarAsistenciaB' + requerimiento.cve_tema"
          >
            <button
              v-if="requerimiento.confirmado != 1"
              :disabled="
                !(
                  usuario.usuario_sistema != 'Instructor' &&
                  requerimiento.calificacion == null &&
                  requerimiento.cve_inscripcion_ai != null &&
                  requerimiento.confirmado == 0 &&
                  requerimiento.prerrequisito == 0
                )
              "
              type="button"
              class="btn waves-effect waves-light btn-info"
              href=""
              @click="ConfirmarAsistencia"
            >
              <i
                v-if="
                  requerimiento.cargando_confirmar_asistencia &&
                    requerimiento.prerrequisito == 0
                "
                class="fas fa-circle-notch fa-spin"
              />
              <i v-else class="fas fa-clipboard-check"></i>
            </button>
            <button v-else type="button"
            disabled
              class="btn waves-effect waves-light btn-info no-action"
              href="">
              <i class="fas fa-check"></i>
            </button>

            <b-popover :target="'confirmarAsistenciaB' + requerimiento.cve_tema" triggers="hover focus">
              <template #title>
                {{ requerimiento.confirmado != 1 ?
                  $t('popovers.confirmar_asistencia.title')
                  :  $t('popovers.asistencia_confirmada.title')
                }}</template>
            </b-popover>
          </span>

        </div>
      </div>
      <div
        :class="
          'confirm row textUnder ' +
            !(
              usuario.usuario_sistema != 'Instructor' &&
              requerimiento.calificacion == null &&
              requerimiento.cve_inscripcion_ai != null &&
              requerimiento.confirmado == 0 &&
              requerimiento.prerrequisito == 0
            )
        "
      >
        {{ $t("page.general.asistencia") }}
      </div>
    </div>
    <div class="col container botButtons" align="center">
      <div class="row">
        <div class="col-auto">
          <button
            :disabled="
              !(
                (requerimiento.accion.includes('presentar_examen') ||
                  requerimiento.presentar_examen) &&
                permitirMaterial &&
                requerimiento.prerrequisito == '0' &&
                (requerimiento.intentos_disponibles != null &&
                  +requerimiento.intentos < +requerimiento.intentos_disponibles)
              )
            "
            type="button"
            class="btn waves-effect waves-light btn-info"
            :id="'presentarExamenB' + requerimiento.cve_tema"
            href=""
            @click="
              () => {
                desactivarPopovers();
                $emit('PresentarExamen');
              }
            "
          >
            <i class="fas fa-edit"></i>
          </button>

            <b-popover :target="'presentarExamenB' + requerimiento.cve_tema" triggers="hover focus">
              <template #title>
                {{  $t('popovers.presentar_examen.title')}}
              </template>
            </b-popover>
        </div>
      </div>
      <div
        :class="
          'row textUnder ' +
            !(
              (requerimiento.accion.includes('presentar_examen') ||
                requerimiento.presentar_examen) &&
              permitirMaterial &&
              requerimiento.prerrequisito == '0' &&
              (requerimiento.intentos_disponibles != null &&
                requerimiento.intentos < requerimiento.intentos_disponibles)
            )
        "
      >
        {{ $t("page.general.examen") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["requerimiento"],
  data() {
    return {
      permitirMaterial: false,
      tipo: "Planeada"
    };
  },
  methods: {
    ...mapActions({
      compareDates: "compararContraHoy"
    }),
    desactivarPopovers() {
      $(".popover").popover("hide");
    },
    ConfirmarAsistencia() {
      this.requerimiento.cargando_confirmar_asistencia = true;
      this.$http
        .post("mobile/cursos/confirmar_asistencia", {
          cve_inscripcion_ai: this.requerimiento.cve_inscripcion_ai
        })
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          if (respuestaJson.resp == "Excelente") {
            this.requerimiento.confirmado = 1;
          } else {
            swal(respuestaJson.resp, "", "error");
          }
        })
        .catch(error => {
          swal("Error", "Problemas para confirmar Asistencia", "error");
        })
        .finally(response => {
          this.requerimiento.cargando_confirmar_asistencia = false;
          $(".popover").popover("hide");
        });
    }
  },
  created() {
    if (this.requerimiento.cve_curso) {
      this.$http
        .get("cursos/by/id/" + this.requerimiento.cve_curso)
        .then(respuesta => {
          if (respuesta.body.length > 0) {
            try {
              let year = this.requerimiento.fecha_curso.split("-")[0];
              let month = this.requerimiento.fecha_curso.split("-")[1];
              let day = this.requerimiento.fecha_curso.split("-")[2];
              let date1 = new Date(year, month - 1, day, 0, 0, 0);
              let date2 = new Date(
                year,
                month - 1,
                Number(day) + Number(respuesta.body[0].dias_acceso),
                23,
                59,
                59
              );
              if (this.compareDates({ dateIni: date1, dateFin: date2 })) {
                this.permitirMaterial = true;
              } else {
                this.permitirMaterial = false;
              }
            } catch (er) {
              console.error("it's not a date");
            }
          }
        })
        .finally(() => {
          $(window).ready(() => {
            $('[data-toggle="popover"]').popover();
          });
        });
      if (this.requerimiento.link.includes("scorm")) {
        this.permitirMaterial = true;
      }
    } else {
      this.permitirMaterial = false;
    }
  },
  computed: {
    usuario() {
      return this.$store.getters.getUsuario;
    }
  },
  mounted() {
    $('[data-toggle="popover"]').popover();
  },
  watch: {
    permitirMaterial() {
      $('[data-toggle="popover"]').popover();
    }
  }
};
</script>

<style scoped>
.botButtons {
  padding: 0;
  margin: -0.5px;
}

.botButtons button {
  color: grey;
  background-color: rgba(148, 148, 148, 0.308);
  border: none;
  max-width: 3em;
  width: 40px;
}
.textUnder {
  font-size: 0.8em;
  text-align: center;
  font-weight: 500;
}

button:disabled {
  cursor: default;
  background-color: rgba(201, 198, 198, 0.356);
  color: rgba(201, 198, 198, 0.685);
}

.textUnder.true {
  color: rgba(201, 198, 198, 0.685);
}

.botButtons > .row {
  width: min-content;
}
.confirm {
  padding-top: 0.15em;
  font-size: 0.7em;
}

.btn {
  font-size: 1.5em;
  padding: 0;
}
.no-action:disabled{
  color: green;
  background-color:rgba(148, 148, 148, 0.308);
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Vistas_Por_Perfil/Tabs/actionsCol.vue